/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './FilterShops.scss';
import BaseReactComponent from '../Util/BaseReactComponent';
import baseComponent from '../../decorators/baseComponent';
import CountryList from '../Util/CountryList';
import FilterShop from './FilterShop';

@baseComponent(styles) class FilterShops extends BaseReactComponent {

  constructor(props) {
    super(props);

    this.state = {};
    this.state.filterShops = [];
    this.state.filterShopsChanged = new Set();
  }

  componentDidMount() {
    this.updateFilterShops(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updateFilterShops(nextProps);
  }

  updateFilterShops(props) {
    let filterShops = CountryList.map(function (c) {
      let shop = props.filterShops ? props.filterShops.find((element) => element.country === c.id) : '';

      if (shop) {
        return shop;
      } else {
        shop = {};
        shop.country = c.id;
        shop.url = '';
      }

      return shop;
    });

    this.setState({
      filterShops: filterShops
    });
  }

  handleShopChanged(shop) {
    let index = this.state.filterShops.findIndex((element) => element.country === shop.country);

    this.state.filterShops[index] = shop;

    this.state.filterShopsChanged.add(index);
  }

  save() {
    let self = this;

    self.state.filterShopsChanged.forEach(function (index) {
      self.props.saveFilterShop(self.state.filterShops[index]);
    });

  }

  render() {
    let subTitle = this.getMessage('title');

    let self = this;

    let filterShops = this.state.filterShops.map(function (f, i) {
      return <FilterShop key={i} filterShop={f} saveFilterShop={self.save.bind(self)} handleFilterShopChanged={self.handleShopChanged.bind(self)}/>;
    });

    return (
      <div className="CommercialOffers">
        <div className="editor-header">
          <div className="container">
            <h1>{subTitle}</h1>
          </div>
        </div>

        <div className="container">
          <form>
            {filterShops}
            <a className="btn btn-primary save-button" onClick={self.save.bind(self)}>{self.getMessage('save-button')}</a>
          </form>
        </div>
      </div>
    );
  }
}

FilterShops.PropTypes = {
  filterShops: React.PropTypes.array,
  saveFilterShop: React.PropTypes.func
};

FilterShops.defaultProps = {
  componentName: 'filter-shops'
};

export default FilterShops;



// WEBPACK FOOTER //
// /src/components/FilterShops/FilterShops.js